// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-component {\n  position: relative;\n  width: auto;\n  height: auto;\n  padding: 0px;\n  margin: 0px; }\n  .img-component .url-img-copy {\n    position: absolute;\n    z-index: 1;\n    top: 20%;\n    left: 0px;\n    width: 100%;\n    height: 80%;\n    background-color: transparent;\n    color: transparent;\n    font-size: 1px; }\n", ""]);
// Exports
module.exports = exports;
